import { useHead } from "@vueuse/head";
import ContactForm from "@/components/ContactForm.vue";
import api from "@/assets/js/utils/api.js";

export default {
  name: "contactView",
  components: {
    ContactForm, // ✅ 註冊組件
  },
  data() {
    return {
      showContactForm: false, // ✅ 控制表單顯示
      contactInfo: {
        address: "高雄市小港區飛機路479巷7號1樓",
        phone: "(07) 803-3324",
      },
    };
  },
  methods: {
    openContactForm() {
      this.showContactForm = true;
    },
    closeContactForm() {
      this.showContactForm = false;
    },
    async fetchContactInfo() {
      try {
        const response = await api.get("/dashboard/contact");
        if (response.data && response.data.success) {
          this.contactInfo = {
            address: response.data.data.Address || this.contactInfo.address,
            phone: response.data.data.Phone || this.contactInfo.phone,
          };
        }
      } catch (error) {
        console.error("取得聯絡資訊失敗:", error);
        // 失敗時保持預設值
      }
    },
  },
  setup() {
    useHead({
      title: "聯絡我們｜安裕和國際企業社 Ann Yoo HoH Company.",
      meta: [
        {
          name: "description",
          content:
            "安裕和國際企業社｜地址：高雄市小港區飛機路479巷7號1樓，電話：(07) 803-3324，Email：annyoohoh@gmail.com，Line：@annyoohoh。歡迎透過電話、Email 或表單與我們聯繫。",
        },
        {
          name: "keywords",
          content:
            "安裕和國際企業社, Ann Yoo HoH Company, 聯絡我們, 高雄醫療設備, 醫療耗材, 客服, 聯絡方式",
        },
        {
          property: "og:title",
          content: "聯絡我們｜安裕和國際企業社 Ann Yoo HoH Company.",
        },
        {
          property: "og:description",
          content:
            "安裕和國際企業社．高雄市小港區飛機路479巷7號1樓．聯絡電話：(07) 803-3324．Line：@annyoohoh．歡迎聯繫我們取得醫療設備與臨床耗材資訊。",
        },
        {
          property: "og:image",
          content: "https://www.annyoohoh.com.tw/img/AYH.f5146a33.png",
        },
        { property: "og:type", content: "website" },
        { property: "og:url", content: "https://www.annyoohoh.com.tw/contact" },
      ],
      link: [
        { rel: "canonical", href: "https://www.annyoohoh.com.tw/contact" },
      ],
    });
  },

  mounted() {
    try {
      // 載入聯絡資訊
      this.fetchContactInfo();

      // 聯絡我們頁面通常是靜態內容，直接觸發預渲染事件
      this.$nextTick(() => {
        if (typeof document !== "undefined") {
          console.log("聯絡我們頁面載入完成，觸發預渲染事件");
          document.dispatchEvent(new Event("render-event"));
        }
      });
    } catch (error) {
      console.error("聯絡我們頁面載入失敗:", error);

      // 🚨 即使載入失敗也要觸發預渲染事件
      this.$nextTick(() => {
        if (typeof document !== "undefined") {
          console.log("聯絡我們頁面載入失敗，仍觸發預渲染事件");
          document.dispatchEvent(new Event("render-event"));
        }
      });
    }
  },
};
